export interface TriggerPair {
    deviceTypeId: string;
    id: string;
}

// A trigger is the (device type, event) pair, not the event alone: the same event id
// is registered under several device types, so the option id has to carry both halves.
const TRIGGER_ID_SEPARATOR = '::';

export const toTriggerOptionId = (deviceTypeId: string, eventId: string): string =>
    `${deviceTypeId}${TRIGGER_ID_SEPARATOR}${eventId}`;

export const fromTriggerOptionId = (optionId: string): TriggerPair | undefined => {
    const separatorIndex = optionId.indexOf(TRIGGER_ID_SEPARATOR);

    if (separatorIndex < 0) {
        return undefined;
    }

    return {
        deviceTypeId: optionId.slice(0, separatorIndex),
        id: optionId.slice(separatorIndex + TRIGGER_ID_SEPARATOR.length),
    };
};
